/**
 * True when an event should offer Allocate sadarat (any required gender slot empty).
 * Prefer per-gender ids/names; fall back to legacy single-slot fields.
 */
export function eventNeedsSadaratAllocation(ev: {
  needSadaratMale?: boolean | null;
  needSadaratFemale?: boolean | null;
  sadaratMaleId?: string | null;
  sadaratFemaleId?: string | null;
  sadaratMaleName?: string | null;
  sadaratFemaleName?: string | null;
  /** Legacy single-slot */
  needSadarat?: boolean | null;
  sadaratId?: string | null;
  sadaratName?: string | null;
}): boolean {
  const usesDual =
    ev.needSadaratMale !== undefined ||
    ev.needSadaratFemale !== undefined ||
    ev.sadaratMaleId !== undefined ||
    ev.sadaratFemaleId !== undefined ||
    ev.sadaratMaleName !== undefined ||
    ev.sadaratFemaleName !== undefined;

  if (usesDual) {
    const needMale = ev.needSadaratMale === true;
    const needFemale = ev.needSadaratFemale === true;
    if (!needMale && !needFemale) return false;
    return (
      slotMissing(needMale, ev.sadaratMaleId, ev.sadaratMaleName) ||
      slotMissing(needFemale, ev.sadaratFemaleId, ev.sadaratFemaleName)
    );
  }

  if (ev.needSadarat === false) return false;
  if (ev.sadaratId != null && String(ev.sadaratId).trim() !== "") return false;
  if (ev.sadaratName?.trim()) return false;
  return true;
}

function slotMissing(
  needed: boolean,
  id: string | null | undefined,
  name: string | null | undefined
): boolean {
  if (!needed) return false;
  if (id != null && String(id).trim() !== "") return false;
  if (name?.trim()) return false;
  return true;
}
